import axiosClient from "./axiosClient";
import { apiEndpoints, secureBusinessKey } from "./apiEndpoints";
import Cookies from "js-cookie";
// Fetch employees for a specific service ID
export const fetchEmployees = ({ serviceId }) =>
  axiosClient.get(apiEndpoints.employees.url(serviceId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employees.uuid,
    },
  });

// Search employees by service ID and branch ID
export const searchEmployees = (serviceId, branchId) =>
  axiosClient.get(apiEndpoints.employeesSearch.url(serviceId, branchId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employeesSearch.uuid,
    },
  });

// Fetch specialists' availability by employee IDs
export const fetchSpecialists = (employeeIds, duration) => {
  const branchId = sessionStorage.getItem("brunch_id");

  const personal_token = Cookies.get("personal_token");

  // console.log("duration", duration);
  if (!branchId || !personal_token) {
    window.location.href = "/logout"; // Redirect if branchId is missing
    return Promise.reject(
      new Error("Branch ID is missing. Redirecting to logout.")
    );
  }
  return axiosClient.post(
    `${process.env.REACT_APP_CALENDAR_BASE_URL}/api/available-specialists`,
    { employee_id: employeeIds, branch_id: branchId, duration: duration },
    {
      headers: {
        "secure-business-key": secureBusinessKey,
        "Content-Type": "application/json",
        "user-token": personal_token,
      },
    }
  );
};

export const getEmployeeName = (userId) => {
  return axiosClient.get(apiEndpoints.employeesName.url(userId), {
    headers: {
      "secure-business-key": secureBusinessKey,
      uuid: apiEndpoints.employeesName.uuid,
      Accept: "application/json",
    },
  });
};
